import { ConfigManager } from '@awayjs/core';
export var Settings = ConfigManager.instance.addStore('playerglobal', {
    /**
     * @description Enable experimental File Picker
     */
    ENABLE_FILE_PICKER: true,
});
